import type { GetInvoicesOverviewsNewResponse } from '@vy/api-definition';
import { vySerialize } from '@vy/utils';
import type { UseQueryOptions } from 'react-query';
import { useInvoicesPageParamsNew } from '../../../pages/invoices/hooks/use-invoices-page-params-new';
import { useInvoicesOverviewsNew } from './use-invoices-overviews-new';

export function useInvoicesOverviewsFromParamsNew(
  options?: UseQueryOptions<GetInvoicesOverviewsNewResponse>,
) {
  const params = useInvoicesPageParamsNew();

  const filters = params.filters?.map((filter) => {
    const { id: _id, ...rest } = filter as typeof filter & { id?: string };
    return rest;
  });

  const payload = {
    search: params.search,
    issuedDates: vySerialize(params.issuedDates),
    filters: vySerialize(filters),
    page: params.page,
    pageSize: params.pageSize,
    sort: vySerialize(params.currentSortModel),
  };

  const queryResult = useInvoicesOverviewsNew(payload, options);

  return {
    ...queryResult,
    page: params.page,
    pageSize: params.pageSize,
    onPageChange: params.onPageChange,
    onPageSizeChange: params.onPageSizeChange,
  };
}
